module.exports = __webpack_public_path__ + "img/app2.b13877e3.png";